import {Injectable} from '@angular/core';
import {BehaviorSubject,  Observable } from 'rxjs';
import {HttpClient, HttpHeaders, HttpErrorResponse, HttpParams} from '@angular/common/http';
import { StudentsDocs } from './documentation.model';
import { AuthService } from '../../../shared/services/auth.service';
import { Procedure } from '../../procedures/procedure.model';

@Injectable()
export class DocumentationService {
  private readonly urlBase = '/api/';

  constructor (private httpClient: HttpClient) {}

  getStudentsDocumentation(business: string, level_id: number, status: number, student_statuses: any, start_date: string, end_date: string, registration: string, start_uploaded_date: string, end_uploaded_date: string) {
    return this.httpClient.get<any[]>(this.urlBase + 'getStudentsDocumentation?business=' + business + '&level_id=' + level_id + '&status=' + status + '&student_statuses=' + student_statuses
    + '&start_date=' + start_date + '&end_date=' + end_date + '&registration=' + registration + '&start_uploaded_date=' + start_uploaded_date + '&end_uploaded_date=' + end_uploaded_date);
  }

  getStudentsDocumentationHist(business: string, level_id: number) {
    return this.httpClient.get<any[]>(this.urlBase + 'getStudentsDocumentationHist?business=' + business + '&level_id=' + level_id);
  }

  getDocumentsByIdecatalu(idecatalu: string, ideplaest: number, level_id: number, business: string, initial: number, required: number, digital: number, visible: number){
    return this.httpClient.get<any>(this.urlBase + "getDocumentsByIdecatalu?idecatalu=" + idecatalu + '&ideplaest=' + ideplaest + '&level_id=' + level_id + '&business=' + business
    + '&initial=' + initial + '&required=' + required + '&digital=' + digital + '&visible=' + visible);
  }

  getNamesDocs(){
    return this.httpClient.get<any>(this.urlBase + "getNamesDocs");
  }

  getLevels(business: number){
    return this.httpClient.get<any>(this.urlBase + "getLevels?business=" + business);
  }

  verifyDocument(business: number, registration: string, name_document: string){
    return this.httpClient.get<any>(this.urlBase + "verifyDocument?business=" + business + "&registration=" + registration + "&name_document=" + name_document);
  }

  verifyRejectedDocument(business: number, registration: string, name_document: string){
    return this.httpClient.get<any>(this.urlBase + "verifyRejectedDocument?business=" + business + "&registration=" + registration + "&name_document=" + name_document);
  }

  deleteDocument(data){
    return this.httpClient.post<any>(this.urlBase + "deleteDocument", data);
  }

  acceptDocument(data){
    return this.httpClient.post<any>(this.urlBase + "acceptDocument", data);
  }

  rejectDocument(data){
    return this.httpClient.post<any>(this.urlBase + "rejectDocument", data);
  }

  setPhotosUploaded(data){
    return this.httpClient.post<any>(this.urlBase + "setPhotosUploaded", data);
  }

  saveComment(data){
    return this.httpClient.post<any>(this.urlBase + "saveComment", data);
  }

  saveInfoCert(data){
    return this.httpClient.post<any>(this.urlBase + "saveInfoCert", data);
  }

  saveEnglishInfo(data){
    return this.httpClient.post<any>(this.urlBase + "saveEnglishInfo", data);
  }

  generateReporDoc(business: number, level_id: number, status: number, student_statuses: any, start_date: string, end_date: string
    , expired: boolean, only_certs: boolean, registration: string, start_uploaded_date: string, end_uploaded_date: string, with_colors = false){
    return this.httpClient.get<any>(this.urlBase + "generateReportDoc?business=" + business + "&level_id=" + level_id + "&status=" +
     status + '&student_statuses=' + student_statuses + '&start_date=' + start_date + '&end_date=' + end_date + '&expired=' + expired
     + '&only_certs=' + only_certs + '&registration=' + registration + '&start_uploaded_date=' + start_uploaded_date + '&end_uploaded_date=' + end_uploaded_date + '&with_colors=' + with_colors);
  }

  generateReportDocHist(business: number, level_id: number){
    return this.httpClient.get<any>(this.urlBase + "generateReportDocHist?business=" + business + "&level_id=" + level_id);
  }

  generateReportDocAll(business: number, level_id: number, statuses: string[], inst: string[], registration = '') {
    let params = new HttpParams()
      .set('business', business.toString())
      .set('level_id', level_id.toString())
      .set('status', statuses.toString())
      .set('inst', inst.toString())
      .set('registration', registration.toString());
    
    return this.httpClient.get<any>(this.urlBase + 'generateReportDocAll', { params });
  }

  getPendingDocuments(business: number, ideplaest: number, level_id: number, idecatalu: string){
    return this.httpClient.get<any>(this.urlBase + "getPendingDocuments?business=" + business +  "&idecatalu=" + idecatalu + '&level_id=' + level_id + '&ideplaest=' + ideplaest);
  }

  sendMail(data): Observable<any>{
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/x-www-form-urlencoded'
        })
      };
    return this.httpClient.post(this.urlBase + 'send', data);
  }

  getStudentStatuses(business: number): Observable<any>{
    return this.httpClient.get(this.urlBase + 'getStudentStatuses?business=' + business);
  }

  getRejectionMotives(): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'getRejectionMotives');
  }

  uploadDocuments(data): Observable<any>{
    return this.httpClient.post<any>(this.urlBase + 'uploadDocuments', data);
  }

  getAluDocId(business: number, aludocIds:number[]): Observable<any>{
    const aludocString = aludocIds.join(',');
    const params = new HttpParams()
      .set('aludoc_id', aludocString)
      .set('business', business.toString());
    return this.httpClient.get(this.urlBase + 'getByAludocId',{params});
  }

  saveProcedureIngles(procedure: any, from: String) {
    return this.httpClient.post(this.urlBase + 'saveProcedureIngles', {procedure, from});
  }

  checkDocCompleteHist(
    registration: string,
    ideplaest: number,
    business: number
  ): Observable<any> {
    const params = new HttpParams()
      .set('registration', registration)
      .set('ideplaest', ideplaest.toString())
      .set('business', business.toString());

    return this.httpClient.get<any>(
      `${this.urlBase}checkDocCompleteHist`,
      { params }
    );
  }

}
